import type { FC } from 'react'
import { KEYBOARD_SHORTCUTS } from './constants'

/**
 * Displays keyboard shortcuts available in the settings modal
 */
export const KeyboardShortcuts: FC = () => {
  return (
    <div className="space-y-2" data-testid="keyboard-shortcuts-list">
      {KEYBOARD_SHORTCUTS.map((shortcut) => (
        <div
          key={shortcut.testId}
          className="flex items-center justify-between text-sm"
          data-testid={shortcut.testId}
        >
          <span className="text-gray-600">{shortcut.description}</span>
          <div className="flex items-center gap-1">
            {shortcut.keys.map((key, index) => (
              <kbd
                key={index}
                className="px-2 py-1 bg-gray-100 border border-gray-300 rounded text-xs font-mono text-gray-700"
              >
                {key}
              </kbd>
            ))}
          </div>
        </div>
      ))}
    </div>
  )
}

export default KeyboardShortcuts
